import type { CloneStatusType, StoreApi } from '../../types.tsx';

export const setCloneFetchStatus =
	(cloneFetchStatus: CloneStatusType) =>
	({ setState }: StoreApi) => {
		setState({
			cloneFetchStatus,
		});
	};
